<ng-content></ng-content>
<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  nzConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayHasBackdrop]="_hasBackdrop"
  (backdropClick)="hide()"
  (detach)="hide()"
  (positionChange)="onPositionChange($event)"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayOpen]="_visible">
  <div class="ant-popover"
    [ngClass]="_classMap"
    [ngStyle]="nzOverlayStyle"
    [@.disabled]="noAnimation?.nzNoAnimation"
    [nzNoAnimation]="noAnimation?.nzNoAnimation"
    [@zoomBigMotion]="'active'">
    <div class="ant-popover-content">
      <div class="ant-popover-arrow"></div>
      <div class="ant-popover-inner">
        <div>
          <div class="ant-popover-inner-content">
            <div class="ant-popover-message">
              <ng-container *nzStringTemplateOutlet="title">
                <ng-container *nzStringTemplateOutlet="nzIcon">
                  <i nz-icon [nzType]="nzIcon || 'exclamation-circle'" nzTheme="fill"></i>
                </ng-container>
                <div class="ant-popover-message-title">{{ title }}</div>
              </ng-container>
            </div>
            <div class="ant-popover-buttons">
              <button nz-button [nzSize]="'small'" (click)="onCancel()">
                <ng-container *ngIf="nzCancelText">{{ nzCancelText }}</ng-container>
                <ng-container *ngIf="!nzCancelText">{{ 'Modal.cancelText' | nzI18n }}</ng-container>
              </button>
              <button nz-button [nzSize]="'small'" [nzType]="nzOkType" (click)="onConfirm()">
                <ng-container *ngIf="nzOkText">{{ nzOkText }}</ng-container>
                <ng-container *ngIf="!nzOkText">{{ 'Modal.okText' | nzI18n }}</ng-container>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>